import React from "react"



class Components extends React.Component {

  

  render()
  {

    return (<div>Components</div>)
  }
}

export default Components;


// WEBPACK FOOTER //
// ./src/js/templates/components.js